export const namespaced = true

export const state = {
  products: [{
    id: 1000231,
    name: 'Проволока порошковая наплавочная АСМ Ø2,4 мм',
    market_price: '734.64',
    unit: 'м.'
  }, {
    id: 1000232,
    name: 'Токарно-карусельный станок с ЧПУ',
    market_price: '12552.00',
    unit: 'шт.'
  }, {
    id: 1000234,
    name: 'Фильтры для очистки воздуха',
    market_price: '4582.00',
    unit: 'шт.'
  }, {
    id: 1000235,
    name: 'Зеркало телескопическое TQC LD3004',
    market_price: '6623.00',
    unit: 'шт.'
  }, {
    id: 1000236,
    name: 'Лупа измерительная Mitutoyo серия 183 ',
    market_price: '8872.00',
    unit: 'шт.'
  }, {
    id: 1000237,
    name: 'Чугун литейный Л-4 ГОСТ 4832-95 группа 3, класс А, категория 1',
    market_price: '30224.00',
    unit: 'тн.'
  }, {
    id: 1000238,
    name: 'Алюминий вторичный АВ87, чушка ГОСТ 295-79',
    market_price: '50200.00',
    unit: 'тн.'
  }, {
    id: 1000239,
    name: 'Бронза в чушках ОЦС 565 ГОСТ 614-97',
    market_price: '78233.00',
    unit: 'тн.'
  }, {
    id: 1000240,
    name: 'Бумага противокоррозионная УНИ 22-80 ГОСТ 16295-93',
    market_price: '142.00',
    unit: 'уп.'
  }, {
    id: 1000241,
    name: 'Перчатки резиновые КЩС-1 АЗРИ ГОСТ 20010-93, ТУ 38.306-5-59-95',
    market_price: '42.00',
    unit: 'пара'
  }, {
    id: 1000242,
    name: 'Лента конвейерная резинотканевая 2М-1200-4-ТК-200-2-5-2-М-РБ',
    market_price: '470242.00',
    unit: 'шт.'
  }, {
    id: 1000243,
    name: 'Услуга механической очистки и бесконтактной мойки полов методом АВД технологического тоннеля КПК-1 на отметке 8,0',
    market_price: '20980.00',
    unit: 'услуга'
  }, {
    id: 1000244,
    name: 'Блок внешний сплит-системы Fujitsu General ASG24U',
    market_price: '15500.00',
    unit: 'шт.'
  }, {
    id: 1000245,
    name: 'Бензопила Stihl MS 230',
    market_price: '23000.00',
    unit: 'шт.'
  }, {
    id: 1000246,
    name: 'Весы аналитические HR-200',
    market_price: '8400.00',
    unit: 'шт.'
  }, {
    id: 1000247,
    name: 'Бумага оберточная марка Е ГОСТ 8273-75',
    market_price: '300.00',
    unit: 'уп.'
  }, {
    id: 1000248,
    name: 'Бумага двухслойная водонепроницаемая марка ДБ ГОСТ 8828-89',
    market_price: '450.00',
    unit: 'уп.'
  }, {
    id: 1000249,
    name: 'Аппарат высокого давления с подогревом воды Karcher HDS 8/18-4M, артикул 1.077-604.0',
    market_price: '19300.00',
    unit: 'шт.'
  }, {
    id: 1000250,
    name: 'Фанера береза/береза ФК II/IV E-1 Ш2, размеры (мм) 1525х1525х4 ГОСТ 3916.1-2018',
    market_price: '500.00',
    unit: 'лист'
  }, {
    id: 1000251,
    name: 'Респиратор 3M 9925',
    market_price: '600',
    unit: 'шт.'
  }, {
    id: 1000252,
    name: 'Услуга по восстановлению кровли',
    market_price: '20500.00',
    unit: 'услуга'
  }, {
    id: 1000253,
    name: 'Станок шлифовально-полировальный DIGIPREP 301',
    market_price: '50200.00',
    unit: 'шт.'
  }, {
    id: 1000254,
    name: 'Очки защитные открытые РОСОМЗ О45-В-2 Визион, артикул 14525',
    market_price: '432.00',
    unit: 'шт.'
  }, {
    id: 1000255,
    name: 'Компьютер панельный Winmate W10I93S-PMH1HM',
    market_price: '50244.00',
    unit: 'шт.'
  }, {
    id: 1000256,
    name: 'Источник бесперебойного питания ИБП Exegate PowerPro PCM-1000VA',
    market_price: '20000.00',
    unit: 'шт.'
  }, {
    id: 1000257,
    name: 'Камера видеонаблюдения черно-белая уличная миниатюрная MBK 1632',
    market_price: '12400.00',
    unit: 'шт.'
  }, {
    id: 1000258,
    name: 'Видеорегистратор BestDVR-803A-S, в комплекте: HDD 3.5" SATA 4x2Tб',
    market_price: '5200.00',
    unit: 'шт.'
  }, {
    id: 1000259,
    name: 'Весы автомобильные электронные ВА-60-22-4',
    market_price: '145200.00',
    unit: 'шт.'
  }, {
    id: 1000260,
    name: 'Смеситель для душа СМ-Д-СТ, со стационарной душевой трубкой и сеткой ГОСТ 25809-96',
    market_price: '1400.00',
    unit: 'шт.'
  }]
}

export const getters = {
  products (state) {
    return state.products
  }
}
